import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClaudeCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 33,
	fill: "none",
	viewBox: "0 0 33 33",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 33,
		height: 33,
		fill: "#C96B49",
		rx: 5
	}), /* @__PURE__ */ _jsx("g", {
		stroke: "#F5E8DE",
		strokeLinecap: "round",
		strokeWidth: 1.575,
		children: /* @__PURE__ */ _jsx("path", { d: "M7.275 16.125H26M22.923 22.923 9.689 9.688M16.125 26V7.275M9.689 22.923 22.923 9.688" })
	})]
});
export default SvgClaudeCode;
